import consumer from './consumer';
import { initSignature } from '../lib/universign';

document.addEventListener('DOMContentLoaded', () => {
  // This function is executed after 3mn if Doclift does not answer
  function docliftDoesNotAnswer() {
    if (!signatureMounted) {
      consumer.disconnect();
      $('#subscriptionStep2').addClass('d-none');
      $('#subscriptionStep3').addClass('d-none');
      $('#subscriptionStep4').addClass('d-none');
      $('#subscriptionStepError').removeClass('d-none');
    }
  }

  function mountSignature(signerId, iframeEndpoint) {
    initSignature('subscriptionStep3', signerId, iframeEndpoint).then(() => {
      signatureMounted = true;
      $('#contractLoadedButton').prop('disabled', false);
      $('#iframeLoadingExplanations').addClass('d-none');
      $('#generatingDocReadyExplanations').removeClass('d-none');
    });

    $('.edit_subscription').on('ajax:success', function () {
      $('#subscriptionStep3').addClass('d-none');
      $('#subscriptionStep4').removeClass('d-none');
      $('.breadcrumb-element:nth-child(3)').removeClass('current');
      $('.breadcrumb-element:nth-child(3)').addClass('past');
      $('.breadcrumb-element:nth-child(4)').removeClass('next');
      $('.breadcrumb-element:nth-child(4)').addClass('current');
      $('#current_step').text('4');
    });
  }

  let signatureMounted = false;
  let docliftDoesNotAnswerTimer = setTimeout(docliftDoesNotAnswer, 180000);

  const signatureElement = $('#signature-subscription-id');
  if (!signatureElement.length) {
    return;
  }

  consumer.subscriptions.create(
    { channel: 'SignatureChannel', subscription_id: signatureElement.data('id') },
    {
      received(data) {
        try {
          if (data.status == 'success') {
            if (data.signer_id) {
              clearTimeout(docliftDoesNotAnswerTimer);
              mountSignature(data.signer_id, data.iframe_endpoint);

              // Display intermediate loading message (final message shown when iframe loads)
              $('#subscriptionStep2 #step-title').text($('#subscriptionStep2').data('title-in-case-of-doc-ready'));
              $('#generatingDocInProgressExplanations').addClass('d-none');
              $('#iframeLoadingExplanations').removeClass('d-none');

              $('#contractLoadedButton').on('click', (_e) => {
                $('#subscriptionStep3').removeClass('d-none');
                $('#subscriptionStep2').addClass('d-none');

                $('.breadcrumb-element:nth-child(2)').removeClass('current');
                $('.breadcrumb-element:nth-child(2)').addClass('past');
                $('.breadcrumb-element:nth-child(3)').removeClass('next');
                $('.breadcrumb-element:nth-child(3)').addClass('current');
                $('#current_step').text('3');
              });
            } else if (data.redirection_url) {
              // When the contract is signed, we redirect to the subscription show.
              window.location.href = data.redirection_url;
            }
          } else {
            setTimeout(() => {
              $('#subscriptionStep2').addClass('d-none');
              $('#subscriptionStep3').addClass('d-none');
              $('#subscriptionStep4').addClass('d-none');
              $('#subscriptionStepError').removeClass('d-none');
            }, 5000);
          }
        } catch {
          setTimeout(() => {
            $('#subscriptionStep2').addClass('d-none');
            $('#subscriptionStep3').addClass('d-none');
            $('#subscriptionStep4').addClass('d-none');
            $('#subscriptionStepError').removeClass('d-none');
          }, 5000);
        }
      },
      rejected() {
        setTimeout(() => {
          $('#subscriptionStep2').addClass('d-none');
          $('#subscriptionStep3').addClass('d-none');
          $('#subscriptionStep4').addClass('d-none');
          $('#subscriptionStepError').removeClass('d-none');
        }, 5000);
        this.uninstall();
      },
    },
  );
});
